// src/config/global.js
const globalConfig = {
    // globalVar: '这是一个全局变量',
    // globalMethod(message) {
    //     console.log('这是一个全局方法++', message);
    // },
};

export default globalConfig;
